import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { ManufacturedHomeDetailsStepComponent } from "../../wizard/wizard-steps/manufactured-home-details-step/manufactured-home-details-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class ManufacturedHomeDetailsStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = ManufacturedHomeDetailsStepComponent;
  }
}
